// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"22514a2a","453":"44dfb448","732":"5a3fa2c7"}[chunkId] + ".chunk.js";
};